export function AccessibilityStatement() {
  return (
    <div className="max-w-4xl mx-auto p-6 text-gray-800">
      {/* כותרת ראשית */}
      <h1 className="text-3xl font-bold mb-6">הצהרת נגישות</h1>

      {/* עדכון תאריך */}
      <p className="mb-4">
        הצהרת הנגישות עודכנה בתאריך <strong>15 במרץ 2025</strong>
      </p>

      {/* פרטי הארגון */}
      <p className="mb-4">
        <strong>אניזון</strong>, פלטפורמה מקוונת המציעה תוכן בידורי ומידע עדכני.
        אנו פועלים רבות על מנת להנגיש את הארגון ואת אתר האינטרנט שלנו לאנשים עם
        מוגבלות, במטרה לקדם שוויון זכויות ושקיפות כלפי כל המבקרים.
      </p>

      {/* מהות האתר */}
      <h2 className="text-2xl font-semibold mb-4">מהות אתר אינטרנט נגיש</h2>
      <p className="mb-4">
        אתר אינטרנט נגיש הוא אתר המאפשר לאדם עם מוגבלות לגלוש באותה רמת יעילות
        והנאה כגולשים אחרים, תוך שימוש ביכולות המערכת עליו הוא פועל ובאמצעות
        טכנולוגיות מסייעות לנגישות.
      </p>

      {/* ביצוע התאמות */}
      <h2 className="text-2xl font-semibold mb-4">
        ביצוע התאמות הנגישות באתר האינטרנט
      </h2>
      <p className="mb-4">
        התאמות הנגישות באתר בוצעו בהתאם לסימן ג': שירותי האינטרנט בתקנות שוויון
        זכויות לאנשים עם מוגבלות (התאמות נגישות לשירות) התשע"ג 2013, לתקן
        הישראלי ת"י 5568 המבוסס על הנחיות WCAG 2.0. האתר הונגש לרמה{' '}
        <strong>AA</strong> ובכפוף לשינויים והתאמות שבוצעו במסמך התקן הישראלי.
      </p>
      <p className="mb-4">
        האתר תומך בשימוש בטכנולוגיות מסייעות כגון תוכנות הקראת מסך, גלישה בעזרת
        מקלדת (למשל, שימוש במקשי Tab ו-Shift+Tab למעבר בין קישורים, מקשי החיצים,
        Enter לבחירה, Esc ליציאה מתפריטים, ולחיצה על H או מספרים למעבר בין
        כותרות).
      </p>
      <p className="mb-4">
        האתר נבדק באופן קבוע (כל 6 חודשים) כדי להבטיח את תחזוקת הנגישות.
      </p>

      {/* פרוט הפטורים */}
      <h2 className="text-2xl font-semibold mb-4">פרוט הפטורים של האתר</h2>
      <p className="mb-4">
        עבור כל דפי האתר, כולל כל רכיבי האתר, קיים פטור מסוג{' '}
        <strong>נטל טכנולוגי</strong>, עם תאריך פקיעת תוקף הפטור ב-
        <strong>31 בדצמבר 2025</strong>.
      </p>

      {/* עמידה חלקית בתקן */}
      <h2 className="text-2xl font-semibold mb-4">
        הצהרה על עמידה חלקית בתקן במקרה של תכני צד ג' (אם קיימים)
      </h2>
      <p className="mb-4">
        בדפי האתר בהם מופיעים תכנים שמקורם בגורמים חיצוניים, נגישות הדף תלויה
        בתכנים שאינם בבעלות "אניזון". לכן, עבור דפים אלו אנו מצהירים על עמידה
        חלקית בתקן.
      </p>

      {/* ישימות מיטבית לנגישות */}
      <h2 className="text-2xl font-semibold mb-4">
        ישימות מיטבית לנגישות באתר האינטרנט
      </h2>
      <p className="mb-4">
        באתר זה, ניתן לגלוש בצורה מיטבית ונגישה באמצעות הדפדפנים הנפוצים. מומלץ
        להשתמש בדפדפנים: Firefox, Opera, Safari, Lynx, Edge או Chrome ובתוכנות
        קוראות מסך כגון NVDA, Jaws או Voiceover.
      </p>

      {/* שלבי ההנגשה */}
      <h2 className="text-2xl font-semibold mb-4">שלבי ההנגשה בהם נמצא האתר</h2>
      <p className="mb-4">
        האתר נמצא כיום בשלב <strong>הנגשה חלקית</strong>. אנו מעריכים שהנגשת
        האתר תושלם עד לתאריך <strong>31 באוגוסט 2025</strong>. עד לתאריך זה,
        יוצעו חלופות נגישות לשירותים המרכזיים באתר.
      </p>

      {/* הסדרי נגישות בארגון */}
      <h2 className="text-2xl font-semibold mb-4">הסדרי נגישות בארגון</h2>
      <p className="mb-4">
        באיזורי הפעילות של "אניזון" (כולל משרדים וסניפים), מתקיימים הסדרי נגישות
        החל מהחניה והתחבורה הציבורית ועד לממשק השירות הסופי (דלפק קבלה או חלל
        שירות). בנוסף, קיימים הסדרי נגישות כמו מעלונים, רמפות וגישה מותאמת
        לאנשים עם מוגבלויות.
      </p>

      {/* דרכי פניה */}
      <h2 className="text-2xl font-semibold mb-4">
        דרכי פניה לבקשות, תקלות נגישות והצעות לשיפור
      </h2>
      <p className="mb-4">
        במידה ומצאתם באתר בעיה בנושא הנגישות או שאתם זקוקים לעזרה, אתם מוזמנים
        לפנות אלינו דרך רכז/ת הנגישות של "אניזון":
      </p>
      <ul className="list-disc text-softText list-inside mb-4">
        <li>
          <strong>רכז/ת הנגישות:</strong> support@anizone.co.il
        </li>
        <li>
          <strong>כתובת מייל:</strong> support@anizone.co.il
        </li>
      </ul>
    </div>
  )
}
